import React from "react";

export const AuthContext = React.createContext({
    currentUser: null,
    refetch: () => {}
});

AuthContext.displayName = "AuthContext";
